import { Injectable } from '@angular/core';
import { Observable, of as observableOf } from 'rxjs';
import { map } from 'rxjs/operators';

import { TarlV3Jsonapi } from '®shared/tarl-v3-jsonapi';

@Injectable()
export class UserSubscribedResourcesService {
  constructor(private tarlV3Jsonapi: TarlV3Jsonapi) {}

  /**
   * Check whether a given user is subscribed to a given resource.
   *
   * Returns true if the user is valid and subscribed; false if they are is valid and not subscribed.
   *
   * @param {string} userId - The user's Persona GUID
   * @param {string} resourceId - The resource's GUID
   * @returns {Observable<boolean>} - whether or not the user is subscribed to the resource
   *
   * @todo Always returns false; fill in with an API that really checks.
   */
  isInUserSubscribedResources(
    _userId: string,
    _resourceId: string,
  ): Observable<boolean> {
    return observableOf(false);
  }

  /**
   * Adds a subscription to a resource for the current user.
   *
   * @param {string} userId - The user's Persona GUID
   * @param {string} resourceId - The resource's GUID
   * @returns {Observable<boolean>} - whether or not subscription is successful
   */
  addToUserSubscribedResources(
    userId: string,
    resourceId: string,
  ): Observable<boolean> {
    const path = this.tarlV3Jsonapi.path(
      '/users/{userId}/relationships/subscribed_resources',
      { userId },
    );
    return this.tarlV3Jsonapi
      .postToManyRelationship(path, [{ id: resourceId, type: 'resources' }])
      .pipe(map(response => response.ok));
  }
}
